@if (newVersionCheckerService.isNewVersionAvailable) {
  <div
    class="new-version-checker"
    style="
      position: absolute;
      z-index: 9999;
      bottom: 0;
      right: 12px;
      cursor: pointer;
    "
  >
    <p-messages severity="info" style="background: rgba(219, 234, 254, 1)">
      <ng-template pTemplate>
        <div class="ml-2 gap-2" (click)="applyUpdate()">
          <h2>New Client Hub version available</h2>
          <p>
            It is essential that you click the button below for everything to
            work normally.
          </p>
          <span class="pulse">
            <button class="btn btn-primary">Update Now</button>
          </span>
        </div>
      </ng-template>
    </p-messages>
  </div>
}
